export default __webpack_public_path__ + "static/media/logisticRedRight.34c345c0.svg";